import { Component, Host, h, Element, Listen, Prop, State } from '@stencil/core';
import { hasTouchSupport, isPlatform } from '@baloise/ds-core';

@Component({
  tag: 'bam-image-teaser',
  styleUrl: 'bam-image-teaser.scss',
})
export class BamImageTeaser {
  @Element() host: HTMLBamImageTeaserElement;
  @Prop() target: '_self' | '_blank';
  @Prop() href?: string;
  @Prop() teaserTitle: string;
  @State() isTouch = isPlatform('touch');
  private figClassList: DOMTokenList;
  private hasImageClass = false;
  private ElementTag: 'div' | 'a';
  private image: string;

  @Listen('resize', { target: 'window' })
  resizeHandler() {
    this.applySizeClasses();
    this.isTouch = isPlatform('touch');
  }

  connectedCallback() {
    this.applySizeClasses();
  }

  componentWillLoad() {
    const children = Array.from(this.host.children);
    children.map(child => {
      if (child.tagName === 'BAM-IMAGE') {
        this.image = child.outerHTML;
      }
    });
  }

  // https://stenciljs.com/docs/component-lifecycle#lifecycle-hierarchy
  // init vars here because inner bam-image component is complete loaded here
  // bam-image -> bam-image-teaser
  componentDidLoad() {
    this.figClassList = this.host.querySelector('figure')?.classList;
    this.hasImageClass = this.figClassList ? this.figClassList.contains('image') : false;
  }

  private applySizeClasses = () => {
    if (this.hasImageClass) {
      this.figClassList.toggle('is-square', isPlatform('touch'));
      this.figClassList.toggle('is-3by2', isPlatform('desktop'));
    }
  };

  render() {
    const { href, target, isTouch, teaserTitle } = this;
    let { ElementTag } = this;
    ElementTag = !isTouch && !hasTouchSupport() && !!this.href ? 'a' : 'div';

    const linkAttributes =
      ElementTag === 'a'
        ? {
            href,
            target,
            'onClick': event => window.track(event),
            'data-tracking-style': 'image-link',
            'data-tracking-context': 'imageTeaser',
            'data-tracking-id': `${teaserTitle}#imageTeaser`,
          }
        : undefined;

    return (
      <Host class="col is-half">
        <ElementTag
          class={{
            'block': true,
          }}
          {...linkAttributes}
          innerHTML={this.image}
        />
        <slot name="headline"></slot>
        <slot name="link"></slot>
      </Host>
    );
  }
}
